export class UserNotificationAction {
  static readonly type = '[UserNotification] Add item';
  constructor(public payload: string) { }
}

export class SetPushTokenAction {
  static readonly type = '[App] SetPushTokenAction';

  constructor(public pushToken: string) {
  }
}

/** Clears push token on server (e.g. logout). */
export class RemovePushTokenAction {
  static readonly type = '[UserNotification] RemovePushTokenAction';
}
